import { useLogin } from '@refinedev/core';
import { Button, Card, Form, Input, Typography } from 'antd';

/** Token sign-in until the admin gets OIDC (§7.3). */
export function Login() {
	const { mutate: login, isPending } = useLogin<{ token: string }>();
	return (
		<div style={ { minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 } }>
			<Card title="C1 Sports Admin" style={ { width: '100%', maxWidth: 420 } }>
				<Typography.Paragraph type="secondary">
					Sign in with an API client token that has the <code>status</code> scope. It is kept in this tab only.
				</Typography.Paragraph>
				<Form layout="vertical" onFinish={ ( values: { token: string } ) => login( values ) }>
					<Form.Item name="token" label="Token" rules={ [ { required: true } ] }>
						<Input.Password autoFocus autoComplete="off" />
					</Form.Item>
					<Button type="primary" htmlType="submit" loading={ isPending } block>
						Sign in
					</Button>
				</Form>
			</Card>
		</div>
	);
}
